export const COMPANY_NAME = "Krost"
